type GetIsOwnerArgs = {
  writerId: string;
  userId: string;
  ssrUserId?: string | null;
  ready: boolean;
};

/**
 *
 * @param args
 * @property args.writerId - the userId that used to compare with.
 * @property args.userId - current user's userId
 * @property args.ssrUserId - current user's userId from ssr
 * @property args.ready - ready from useUserContext
 * @returns boolean
 */
export const getIsOwner = (args: GetIsOwnerArgs) => {
  const { ready, ssrUserId, writerId, userId } = args;
  if (!ready && ssrUserId === writerId) return true;
  if (ready && userId === writerId) return true;
  return false;
};
